import { Button, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Fragment } from 'react';
import { makeStyles } from 'tss-react/mui';
import { IRegistration } from '../../yogAdmin.duck';

type IModalProps = {
  cancelCallBack: () => void;
  confirmCallBack: (registration: IRegistration) => void;
  registration: IRegistration;
  isUpdatingRegistration: boolean;
};

export function ConfirmMarkAsIncompleteModal({
  cancelCallBack,
  confirmCallBack,
  registration,
  isUpdatingRegistration
}: IModalProps) {
  const { classes } = useStyles();
  const firstName = registration?.member?.firstName || '';
  const lastName = registration?.member?.lastName || '';

  return (
    <Fragment>
      <DialogTitle className={classes.dialogTitle}>Are you sure?</DialogTitle>
      <DialogContent className={classes.container}>
        <div className={classes.text}>
          You are marking registration as incomplete for:{' '}
          <span className={classes.name}>
            {firstName} {lastName}
          </span>
        </div>
      </DialogContent>
      <DialogActions>
        <Button disableRipple className="button-primary cancel-button" onClick={cancelCallBack}>
          <span className="button-primary-label">Cancel</span>
        </Button>
        <Button
          disableRipple
          disabled={isUpdatingRegistration}
          className="button-primary"
          style={{ backgroundColor: '#067bc2' }}
          onClick={() => confirmCallBack(registration)}
        >
          <span className="button-primary-label label-white">Mark as Incomplete</span>
        </Button>
      </DialogActions>
    </Fragment>
  );
}

export const useStyles = makeStyles()(() => ({
  dialogTitle: {
    '> h2': {
      fontSize: '18px',
      fontWeight: 'bold',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontFamily: 'Rubik'
    }
  },
  text: {
    fontFamily: 'Rubik'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    fontFamily: 'Rubik',
    marginBottom: '16px'
  },
  name: {
    fontWeight: 'bold',
    textTransform: 'capitalize'
  }
}));
